import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, SparklesIcon } from 'lucide-react';
type PremiumMaterial = {
  n: string;
  title: string;
  tagline: string;
  image: string;
  highlights: string[];
  closing: string;
};
const premium: PremiumMaterial[] = [{
  n: '05',
  title: 'Neurociencia',
  tagline: 'Entendé qué pasa en tu cerebro cuando el trabajo te pone bajo presión.',
  image: 'https://cdn.magicpatterns.com/uploads/i8B9kzC7TgVrTfZ2XNc6PG/material_premium_Neurociencia_(1).png',
  highlights: ['Cómo responde tu cerebro y tu cuerpo al estrés.', 'Respiración y regulación del estado.', 'Qué ocurre cuando nombrás lo que sentís.', 'Por qué los pendientes siguen ocupando tu mente.', 'Amenaza vs. desafío.', 'Atención y rendimiento bajo presión.', 'Estrés por situaciones que todavía no ocurrieron.', 'Tu patrón personal frente al estrés.'],
  closing: 'Experimentá, observá y entendé cómo respondés al estrés laboral.'
}, {
  n: '06',
  title: 'El Umbral del Descanso',
  tagline: 'El trabajo terminó. Tu cabeza también necesita enterarse.',
  image: 'https://cdn.magicpatterns.com/uploads/nWACxp36EVLT25PhGFJ6ur/material_premium_umbral_del_descanso_(1).png',
  highlights: ['Qué ocurre en los minutos previos al sueño.', 'Cómo cerrar mentalmente la jornada.', 'La Técnica del Umbral del Descanso.', 'Frases de cierre realistas.', 'Descarga mental de 2 minutos.', 'Cómo dejar de darle vueltas a los problemas.', 'Práctica de 7 noches.', 'Herramienta de cierre nocturno.'],
  closing: 'Dejá los pendientes para mañana y recuperá tus noches para descansar.'
}];
export function PremiumMaterialsSection() {
  return <section className="w-full bg-bg-warm pb-20 md:pb-28 px-4" data-id="element-214" data-mp="2vc07tgnjohcs">
      <div className="max-w-6xl mx-auto" data-id="element-215" data-mp="30b3c2yvpajjp">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-216" data-mp="309s04bs3q5hi">
          <div className="inline-flex items-center gap-2 bg-ink text-white px-4 py-1.5 rounded-full mb-5" data-id="element-217" data-mp="3qm55hx1ast4c">
            <SparklesIcon className="w-3.5 h-3.5" data-id="element-218" data-mp="3lm913woouzo9" />
            <span className="text-xs font-bold tracking-widest" data-id="element-219" data-mp="3lolsf0gc6mdz">
              MATERIALES PREMIUM INCLUIDOS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-220" data-mp="3cuqn9sf7svyc">
            

            
          </h2>
        </motion.div>

        <div className="space-y-8" data-id="element-221" data-mp="32wawxro0hqpw">
          {premium.map(m => <motion.article key={m.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="relative overflow-hidden bg-ink text-white rounded-3xl p-6 md:p-9 shadow-2xl" data-id="element-222" data-mp="32uq0fwi4zxpe">
              <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-rose/20 blur-3xl pointer-events-none" data-id="element-223" data-mp="s3ge9qw3zt8b" />
              <div className="absolute -bottom-28 -left-20 w-72 h-72 rounded-full bg-gold/25 blur-3xl pointer-events-none" data-id="element-224" data-mp="2a0jtaq03scyf" />

              <div className="relative" data-id="element-225" data-mp="2eyv1yxenwhf2">
                {/* Header: mockup + title */}
                <div className="flex flex-col sm:flex-row items-center sm:items-end gap-6 md:gap-8 mb-6" data-id="element-226" data-mp="2jrxy9datq4yy">
                  <img src={m.image} alt={m.title} className="w-40 sm:w-44 md:w-52 h-auto flex-shrink-0 rounded-xl shadow-2xl" data-id="element-227" data-mp="2ns82akf22lb6" />
                  <div className="text-center sm:text-left" data-id="element-228" data-mp="1w1tu94tq437f">
                    
                    <h3 className="font-serif font-bold text-2xl md:text-3xl uppercase leading-tight" data-id="element-229" data-mp="1w3xxdkjssy6n">
                      {m.title}
                    </h3>
                    <p className="text-white/75 text-base leading-relaxed mt-3" data-id="element-230" data-mp="253kwu0syvtx2">
                      {m.tagline}
                    </p>
                  </div>
                </div>

                <ul className="border-t border-white/15 pt-6 grid sm:grid-cols-2 gap-x-8 gap-y-2.5" data-id="element-231" data-mp="3ggvt0vikq2w4">
                  {m.highlights.map((h, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-232" data-mp="3f11ijik39i5m" data-mpi={j}>
                      <span className="flex-shrink-0 w-5 h-5 rounded-full bg-white/15 flex items-center justify-center mt-0.5" data-id="element-233" data-mp="3a2849nwz9n4e">
                        <CheckIcon className="w-3 h-3 text-white" strokeWidth={3} data-id="element-234" data-mp="3o2r9yodz0h3e" />
                      </span>
                      <span className="text-white/90 text-sm" data-id="element-235" data-mp="3jyb58qg3ffpr">{h}</span>
                    </li>)}
                </ul>

                <p className="font-serif-italic text-rose-soft text-base md:text-lg mt-6" data-id="element-236" data-mp="1rn2364lt2mq">
                  {m.closing}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}